import { Checkbox } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Button } from "@components/Button";
import { COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { getUserExtraCustomers } from "@utils/getUserExtraCustomers";
import { fetchAPI } from "@utils/https/fetchAPI";

const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

// const InnerContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   flex-grow: 1;
//   overflow: hidden;
// `;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

const SectionSelectLocation = styled.div`
  height: calc(100% - 58px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
// locationList
export const FormManageLocation = ({
  selectedData,
  locationList,
  setIsModalVisible,
  setSelectedData,
  setDataList,
}) => {
  const allCustomers = getUserExtraCustomers();

  console.log("selectedData :>> ", selectedData);
  const user_id = _.get(selectedData, ["id"]);
  const category_customer_id = _.get(selectedData, ["category_customer_id"]);

  const userExtraCustomerIds = _.chain(selectedData)
    .get(["userExtraCustomers"])
    .map((item, index) => {
      return _.get(item, ["category_customer_id"]);
    })
    .concat([category_customer_id])
    .value();

  const userManageLocations = _.chain(selectedData)
    .get(["manage_location"])
    .thru((item) => {
      return _.map(item, (locationId) => _.toInteger(locationId));
    })
    .value();

  console.log("userManageLocations :>> ", userManageLocations);

  // const locationList = _.map(new Array(100), (item, index) => {
  //   console.log("index :>> ", index);
  //   return {
  //     id: index + 1,
  //     name: `mock ${index + 1}`,
  //     category_customer_id: 1,
  //   };
  // });

  const filteredLocationList = _.filter(locationList, (item) => {
    const filterCustomerId = _.get(item, ["category_customer_id"]);
    if (_.isEmpty(userExtraCustomerIds)) {
      return _.get(item, ["category_customer_id"]) === category_customer_id;
    }
    return _.includes(userExtraCustomerIds, filterCustomerId);
  });

  const initSelectedLocation =
    _.size(userManageLocations) === 0
      ? _.map(filteredLocationList, (item) => _.get(item, ["id"]))
      : _.map(userManageLocations, (item) => item);

  const [selectedLocation, setSelectedLocation] =
    useState(initSelectedLocation);

  const onHandleUpdateManageLocation = async () => {
    const updateManageLocation = _.chain(selectedLocation)
      .thru((item) => {
        if (_.size(item) === _.size(filteredLocationList)) {
          return null;
        }
        return _.isEmpty(item) ? null : item;
      })
      .value();

    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/user-update-manage-location",
      isAuth: true,
      data: {
        user_id,
        manage_location: updateManageLocation,
      },
    });
    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      console.log("results :>> ", results);
      const updateData = _.chain(results)
        .thru((item) => {
          const userId = _.chain(item).get(["user_id"]).toInteger().value();
          const manage_location = _.chain(item)
            .get(["manage_location"])
            .value();

          return { id: userId, manage_location };
        })
        .value();

      console.log("updateData :>> ", updateData);
      toast.success("Update User Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      setSelectedData(null);
      setDataList((prev) => {
        const updateDataList = _.map(prev, (item) => {
          return _.get(item, ["id"]) === _.chain(updateData).get(["id"]).value()
            ? { ...item, ...updateData }
            : item;
        });

        console.log("updateDataList :>> ", updateDataList);
        return updateDataList;
      });
    }

    console.log("updateManageLocation :>> ", updateManageLocation);
  };

  const onChangeCheckbox = ({ locationId }) => {
    const updateSelectedLocation = _.includes(selectedLocation, locationId)
      ? _.filter(selectedLocation, (item) => item !== locationId)
      : [...selectedLocation, locationId];
    setSelectedLocation(updateSelectedLocation);
  };

  return (
    <FormContainer>
      <Line />
      <SectionSelectLocation>
        {_.map(filteredLocationList, (item, index) => {
          const locationId = _.get(item, ["id"]);
          const locationName = _.get(item, ["name"]);
          return (
            <Checkbox
              key={index}
              checked={_.includes(selectedLocation, locationId)}
              onChange={() => onChangeCheckbox({ locationId })}
            >
              {locationName}
            </Checkbox>
          );
        })}
      </SectionSelectLocation>

      <ButtonContainer>
        <Button
          type="submit"
          color={COLOR_GREEN}
          fontColor={COLOR_WHITE}
          fontSize="16px"
          padding="5px 20px"
          onClick={() => onHandleUpdateManageLocation()}
        >
          Save
        </Button>
      </ButtonContainer>
    </FormContainer>
  );
};
